import React from 'react';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { FormHelperText, InputLabel, MenuItem, Select } from '@material-ui/core';

// context
import { usePracticeState } from '../../../context/PracticeContext';

const CaseAttributes = ({ newOrder, formErrors, onTextFieldChange }) => {
    const practiceState = usePracticeState();

    // Handler for Autocomplete to keep the practiceId in sync
    const handlePracticeChange = (event, newValue) => {
        const simulatedEvent = {
            target: {
                name: 'practiceId',
                value: newValue ? newValue.practiceId : '',
            },
        };
        onTextFieldChange(simulatedEvent);
    };

    // Get the selected practice object
    const selectedPractice = (practiceState.practices?.items || []).find(
        (practice) => practice.practiceId === newOrder.practiceId
    );

    return (
        <>
            <FormControl key="practice" variant="outlined" onChange={onTextFieldChange} style={{ marginBottom: 35 }}>
                <Autocomplete
                    labelId="practice-label"
                    id="practice"
                    options={practiceState.practices?.items || []}
                    getOptionLabel={(option) => option?.name || ''}
                    value={selectedPractice || null}
                    onChange={handlePracticeChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            name="practiceSearch"
                            label="Select a practice"
                            variant="outlined"
                            required
                            error={formErrors.practiceId}
                            style={{ marginBottom: 15 }}
                        />
                    )}
                />
            </FormControl>

            <TextField
                id="prescriberName"
                label="Prescriber Name"
                onChange={onTextFieldChange}
                name="prescriberName"
                value={newOrder.prescriberName || ''}
                variant="outlined"
                style={{ marginBottom: 35 }}
                helperText="Please enter the prescriber's first name and last name"
                required
                error={formErrors.prescriberName}
            />

            <TextField
                id="patientName"
                label="Patient Name"
                onChange={onTextFieldChange}
                value={newOrder.patientName || ''}
                name="patientName"
                variant="outlined"
                style={{ marginBottom: 35 }}
                helperText="Please enter the patient's first name and last name"
                required
                error={formErrors.patientName}
            />

            <FormControl
                key="patientGender"
                variant="outlined"
                onChange={onTextFieldChange}
                style={{ marginBottom: 35 }}
                error={formErrors.patientGender}
                required
            >
                <InputLabel id="patientGender-label" required={true}>
                    Patient Gender
                </InputLabel>

                <Select
                    labelId="patientGender-label"
                    id="patientGender"
                    value={newOrder.patientGender || ''}
                    name="patientGender"
                    onChange={onTextFieldChange}
                    label="Patient Gender"
                    error={formErrors.patientGender}
                    required
                >
                    {['Male', 'Female', 'Prefer not to say'].map((item) => (
                        <MenuItem key={item} value={item}>
                            {item}
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText>Please select the patient's gender</FormHelperText>
            </FormControl>

            <TextField
                id="patientDOB"
                label="Patient Date of Birth"
                onChange={onTextFieldChange}
                name="patientDOB"
                value={newOrder.patientDOB || ''}
                variant="outlined"
                type="date"
                style={{ marginBottom: 35 }}
                helperText="Patient must be between 8 and 90 years old if provided"
                error={formErrors.patientDOB}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{
                    min: (() => {
                        const today = new Date();
                        const minDate = new Date(today.getFullYear() - 90, today.getMonth(), today.getDate());
                        return minDate.toISOString().split('T')[0];
                    })(), // 90 years ago
                    max: (() => {
                        const today = new Date();
                        const maxDate = new Date(today.getFullYear() - 8, today.getMonth(), today.getDate());
                        return maxDate.toISOString().split('T')[0];
                    })(), // 8 years ago
                }}
            />
        </>
    );
};

export default CaseAttributes;
